"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Afro_1 = require("./Afro");
var Bald_1 = require("./Bald");
var BaldSides_1 = require("./BaldSides");
var BaldTop_1 = require("./BaldTop");
var Bangs_1 = require("./Bangs");
var BangsFilled_1 = require("./BangsFilled");
var Bear_1 = require("./Bear");
var Bun_1 = require("./Bun");
var Buns_1 = require("./Buns");
var BunCurly_1 = require("./BunCurly");
var FlatTop_1 = require("./FlatTop");
var FlatTopLong_1 = require("./FlatTopLong");
var HatHip_1 = require("./HatHip");
var Long_1 = require("./Long");
var LongAfro_1 = require("./LongAfro");
var LongBangs_1 = require("./LongBangs");
var LongCurly_1 = require("./LongCurly");
var Medium_1 = require("./Medium");
var MediumBangs_1 = require("./MediumBangs");
var MediumBangsFilled_1 = require("./MediumBangsFilled");
var MediumLong_1 = require("./MediumLong");
var MediumShort_1 = require("./MediumShort");
var MediumStraight_1 = require("./MediumStraight");
var Mohawk_1 = require("./Mohawk");
var MohawkDino_1 = require("./MohawkDino");
var Pomp_1 = require("./Pomp");
var ShavedRight_1 = require("./ShavedRight");
var ShavedSides_1 = require("./ShavedSides");
var ShavedWavy_1 = require("./ShavedWavy");
var Short_1 = require("./Short");
var ShortCurly_1 = require("./ShortCurly");
var ShortMessy_1 = require("./ShortMessy");
var ShortScratch_1 = require("./ShortScratch");
var ShortVolumed_1 = require("./ShortVolumed");
var ShortWavy_1 = require("./ShortWavy");
var BantuKnots_1 = require("./BantuKnots");
var Beanie_1 = require("./Beanie");
var BunFancy_1 = require("./BunFancy");
var CornRows_1 = require("./CornRows");
var CornRowsFilled_1 = require("./CornRowsFilled");
var GrayBun_1 = require("./GrayBun");
var GrayMedium_1 = require("./GrayMedium");
var GrayShort_1 = require("./GrayShort");
var Hijab_1 = require("./Hijab");
var MediumShade_1 = require("./MediumShade");
var Turban_1 = require("./Turban");
var Twists_1 = require("./Twists");
var TwistsVolumed_1 = require("./TwistsVolumed");
var DocBouffant_1 = require("./DocBouffant");
var DocShield_1 = require("./DocShield");
var DocSurgery_1 = require("./DocSurgery");
exports.Hair = {
    Afro: Afro_1.Afro,
    Bald: Bald_1.Bald,
    BaldSides: BaldSides_1.BaldSides,
    BaldTop: BaldTop_1.BaldTop,
    Bangs: Bangs_1.Bangs,
    BangsFilled: BangsFilled_1.BangsFilled,
    Bear: Bear_1.Bear,
    Bun: Bun_1.Bun,
    BunCurly: BunCurly_1.BunCurly,
    Buns: Buns_1.Buns,
    FlatTop: FlatTop_1.FlatTop,
    FlatTopLong: FlatTopLong_1.FlatTopLong,
    HatHip: HatHip_1.HatHip,
    Long: Long_1.Long,
    LongAfro: LongAfro_1.LongAfro,
    LongBangs: LongBangs_1.LongBangs,
    LongCurly: LongCurly_1.LongCurly,
    Medium: Medium_1.Medium,
    MediumBangs: MediumBangs_1.MediumBangs,
    MediumBangsFilled: MediumBangsFilled_1.MediumBangsFilled,
    MediumLong: MediumLong_1.MediumLong,
    MediumShort: MediumShort_1.MediumShort,
    MediumStraight: MediumStraight_1.MediumStraight,
    Mohawk: Mohawk_1.Mohawk,
    MohawkDino: MohawkDino_1.MohawkDino,
    Pomp: Pomp_1.Pomp,
    ShavedRight: ShavedRight_1.ShavedRight,
    ShavedSides: ShavedSides_1.ShavedSides,
    ShavedWavy: ShavedWavy_1.ShavedWavy,
    Short: Short_1.Short,
    ShortCurly: ShortCurly_1.ShortCurly,
    ShortMessy: ShortMessy_1.ShortMessy,
    ShortScratch: ShortScratch_1.ShortScratch,
    ShortVolumed: ShortVolumed_1.ShortVolumed,
    ShortWavy: ShortWavy_1.ShortWavy,
    BantuKnots: BantuKnots_1.BantuKnots,
    Beanie: Beanie_1.Beanie,
    BunFancy: BunFancy_1.BunFancy,
    CornRows: CornRows_1.CornRows,
    CornRowsFilled: CornRowsFilled_1.CornRowsFilled,
    GrayBun: GrayBun_1.GrayBun,
    GrayMedium: GrayMedium_1.GrayMedium,
    GrayShort: GrayShort_1.GrayShort,
    Hijab: Hijab_1.Hijab,
    MediumShade: MediumShade_1.MediumShade,
    Turban: Turban_1.Turban,
    Twists: Twists_1.Twists,
    TwistsVolumed: TwistsVolumed_1.TwistsVolumed,
    DocBouffant: DocBouffant_1.DocBouffant,
    DocSurgery: DocSurgery_1.DocSurgery,
    DocShield: DocShield_1.DocShield
};
//# sourceMappingURL=z_options.js.map